import { RootState } from "../../../Redux/store";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import React from "react";

interface PublicRouteProps {
  children: React.ReactNode;
  isAuthPage?: boolean;
  isAdmin?: boolean;
}

const PublicRoute: React.FC<PublicRouteProps> = ({
  children,
  isAuthPage = false,
  isAdmin = false,
}) => {
  const { token, user, admin, adminToken } = useSelector(
    (state: RootState) => state.auth,
  );
  const isAuthenticated = token && user;
  const isAdminAuthenticated = admin && adminToken;
  const isDoorAdminRole = admin?.role === "DoorLogAdmin";

  if (isDoorAdminRole && isAdmin && isAdminAuthenticated && isAuthPage) {
    return <Navigate to="/admin/reports/doorhistory" replace />;
  }

  if (isAdmin && isAdminAuthenticated && isAuthPage) {
    return <Navigate to="/admin" replace />;
  }

  if (isAuthenticated && isAuthPage && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
